import React from "react";

interface StatCardProps {
	title: string;
	children: React.ReactNode;
	className?: string;
}

export const StatCard: React.FC<StatCardProps> = React.memo(
	({ title, children, className = "" }) => (
		<div
			className={`bg-gradient-to-br from-white to-gray-50 p-6 rounded-2xl shadow-lg \
       border border-gray-100 hover:shadow-xl transition-shadow duration-300 ${className}`}
		>
			<h3 className="text-xl font-bold mb-4 text-gray-800 flex items-center gap-2">
				{title}
			</h3>
			{children}
		</div>
	)
);
